import { createContext, useContext } from 'react';
import { Role, User, UserOperator } from '../types/user';

export interface CurrentUser {
  user: User;
  userOperator: UserOperator | null;
  isFetching: boolean;
  isOperator: boolean;
  hasRole: (...requiredRole: Role[]) => boolean;
}

const CurrentUserContext = createContext<CurrentUser>(
  null as unknown as CurrentUser,
);

export default CurrentUserContext;

export const useCurrentUser = () => {
  const currentUser = useContext(CurrentUserContext);
  if (!currentUser) {
    throw new Error('Not logged user');
  }
  return currentUser;
};
